<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Edit Perk</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the content of the Perk?
              </div>
              <v-text-field
                v-model="content"
                hide-details
                dense
                outlined
                placeholder="Perk Content"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Schedule At</div>
              <v-text-field
                readonly
                v-model="scheduledAtDateString"
                hide-details
                dense
                outlined
                placeholder="Scheduled Date"
                @click="openScheduleDateDialog"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Expires At</div>
              <v-text-field
                v-model="expiresAtDateString"
                readonly
                hide-details
                dense
                outlined
                placeholder="Expire Date"
                @click="openExpiryDateDialog"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-combobox
                :loading="loading"
                v-model="entity"
                :items="reviewedEntities"
                cache-items
                :search-input.sync="searchTerm"
                hide-details
                return-object
                item-text="title"
                item-value="title"
                placeholder="Select Entity"
                no-data-text="Type a name of an entity to search"
                outlined
                chips
                dense
                @change="entitySelected"
              ></v-combobox>
            </v-flex>
          </v-layout>

          <v-layout v-if="entity">
            <!-- {{ entity }} -->
            <v-btn
              v-if="entity.instagram"
              icon
              target="_blank"
              :href="entity.instagram"
            >
              <v-icon>mdi-instagram </v-icon>
            </v-btn>
            <v-btn
              v-if="entity.facebook"
              icon
              target="_blank"
              :href="entity.facebook"
            >
              <v-icon>mdi-facebook </v-icon>
            </v-btn>
            <v-btn
              v-if="entity.website"
              icon
              target="_blank"
              :href="entity.website"
            >
              <v-icon>mdi-globe </v-icon>
            </v-btn>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Region</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Placement</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="['happy-hour', 'food']"
                v-model="placement"
                item-text="name"
                placeholder="Placement"
              >
              </v-select>
            </v-flex>
          </v-layout>

          <gallery-image-select-section
            v-if="state === 'scheduled' || state === 'updated'"
            ref="galleryImageSelectSectionContentRef"
            @imageSelected="galleryImageSelectedForContent"
          />
          <v-layout v-if="image.url" class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Image URL</div>
              <v-text-field
                v-model="image.url"
                hide-details
                dense
                outlined
                readonly
                placeholder="Ex: gift"
              ></v-text-field>
            </v-flex>
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Image Thumbnail</div>
              <v-text-field
                v-model="image.thumbnail"
                hide-details
                readonly
                dense
                outlined
                placeholder="Ex: gift"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="image.url && !selectedFromGalleryForContent"
            class="mt-3"
          >
            <v-flex>
              <v-card>
                <v-img
                  gradient="to top left, rgba(0,0,0,0), rgba(0,0,0,.7)"
                  aspect-ratio="1"
                  :lazy-src="image.url"
                  :src="image.url"
                >
                  <v-layout v-if="state === 'scheduled' || state === 'updated'">
                    <v-btn
                      icon
                      small
                      @click="galleryImageSelectedForContent({})"
                    >
                      <v-icon color="white"> mdi-close </v-icon>
                    </v-btn>
                  </v-layout>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Next Step Options</div>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Message</div>
              <v-text-field
                v-model="subCollections.toInsert.message"
                hide-details
                dense
                outlined
                placeholder="Message"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <gallery-image-select-section
            ref="galleryImageSelectSectionRef"
            @imageSelected="galleryImageSelectedForNextStep"
          />
          <v-layout
            v-if="subCollections.image.url && !selectedFromGalleryForNextStep"
            class="mt-3"
          >
            <v-flex>
              <v-card>
                <v-img
                  gradient="to top left, rgba(0,0,0,0), rgba(0,0,0,.7)"
                  aspect-ratio="1"
                  :lazy-src="subCollections.image.url"
                  :src="subCollections.image.url"
                >
                  <v-layout v-if="state === 'scheduled' || state === 'updated'">
                    <v-btn
                      icon
                      small
                      @click="galleryImageSelectedForNextStep({})"
                    >
                      <v-icon color="white"> mdi-close </v-icon>
                    </v-btn>
                  </v-layout>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <time-and-date-select-dialog
      @onDateSelected="onExpiryDateSelected"
      ref="ExpiryTimeAndDateDialogRef"
    />
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import firebase from 'firebase';
import { auth } from '@/plugins/firebase';
import moment from 'moment';
import TimeAndDateSelectDialog from './TimeAndDateSelectDialog.vue';
import GalleryImageSelectSection from '../../Assets/components/GalleryImageSelectSection.vue';
// import ImageCropperDialog from "./ImageCropperDialog.vue";
import _ from 'lodash';
export default {
  props: {
    selectedRegion: {
      type: Object,
      default: function() {
        return {};
      },
    },
    collection: {
      type: String,
      default: function() {
        return {};
      },
    },
  },
  components: {
    TimeAndDateSelectDialog,
    GalleryImageSelectSection,
    // ImageCropperDialog,
  },

  data() {
    return {
      dialog: false,
      id: '',
      scheduleDateDialog: false,
      expiryDateDialog: false,
      scheduledAtDateField: '',
      expiresAtDateField: '',
      scheduledAt: '',
      region: '',
      entity: null,
      searchTerm: '',
      loading: false,
      state: '',
      createdBy: '',
      placement: '',

      content: '',
      cost: 0,
      image: {
        thumbnail: '',
        url: '',
        firebaseUrl: '',
      },

      location: {
        latitude: '',
        longitude: '',
      },

      expiresAt: '',
      subCollections: {
        image: {
          firebaseUrl: '',
          url: '',
          thumbnail: '',
        },
        collectionName: '',
        toInsert: {
          attachment: '',
          for: 'user',
          message: '',
          state: '',
        },
      },
      selectedFromGalleryForNextStep: false,
      selectedFromGalleryForContent: false,
    };
  },
  computed: {
    ...mapState('$_home', ['regions']),
    ...mapState('$_entity', ['reviewedEntities']),

    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },
    expiresAtDateString() {
      if (this.expiresAtDateField) {
        return this.iMoment(this.expiresAtDateField);
      } else {
        return this.expiresAt;
      }
    },

    changeFieldsCopy() {
      return {
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: 'scheduled',

        type: 'perk',
        region: this.region,
        entity: this.entity,
        createdBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },
        data: {
          content: this.content,
          placement: this.placement,
          entityId: this.entity.id,
          entityTitle: this.entity.title,
          image: {
            thumbnail: this.image.thumbnail,
            url: this.image.url,
          },
          location: new firebase.firestore.GeoPoint(
            parseFloat(this.region.latitude),
            parseFloat(this.region.longitude),
          ),
          expiresAt: this.iMoment(this.expiresAtDateString),
          subCollections: {
            image: {
              url: this.subCollections.image.url,
              thumbnail: this.subCollections.image.thumbnail,
            },
            collectionName: 'nextstep',
            toInsert: {
              attachment: this.subCollections.image.url,
              for: 'user',
              message: this.subCollections.toInsert.message,
              state: '',
            },
          },
        },
      };
    },

    changeFields() {
      return {
        id: this.id,
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: this.state,

        type: 'perk',
        region: this.region,
        entity: this.entity,
        createdBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },
        data: {
          content: this.content,
          placement: this.placement,
          entityId: this.entity.id,
          entityTitle: this.entity.title,
          image: {
            thumbnail: this.image.thumbnail,
            url: this.image.url,
          },
          location: new firebase.firestore.GeoPoint(
            parseFloat(this.region.latitude),
            parseFloat(this.region.longitude),
          ),
          expiresAt: this.iMoment(this.expiresAtDateString),
          subCollections: {
            image: {
              url: this.subCollections.image.url,
              thumbnail: this.subCollections.image.thumbnail,
            },
            collectionName: 'nextstep',
            toInsert: {
              attachment: this.subCollections.image.url,
              for: 'user',
              message: this.subCollections.toInsert.message,
              state: '',
            },
          },
        },
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchEntities(e);
    }, 300),
  },
  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
  },
  methods: {
    ...mapActions({
      createNewPerk: '$_content/createNewContent',
      uploadImage: '$_content/uploadImage',
      getRegions: '$_home/getContent',
      getPerks: '$_content/getContent',
      updatePerk: '$_content/updateContent',
      getPerksByRegion: '$_content/getContentByRegion',
      searchEntitiesAction: '$_entity/searchContent',
    }),
    searchEntities(searchTerm) {
      this.loading = true;
      console.log('searching Tags: ', searchTerm);

      this.searchEntitiesAction({
        collection: 'entities',
        mutation: 'updateReviewedEntities',
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    entitySelected(entity) {
      console.log('Selected Entity: ', entity);
      if (entity) {
        // this.pinType = entity.default ? entity.default.pinType : {};
        this.linkUrl = entity.default ? entity.default.linkUrl : '';
        this.linkName = entity.default ? entity.default.linkName : '';
        this.region = entity.region;
        this.latitude = entity.location.latitude;
        this.longitude = entity.location.longitude;
      } else {
        this.latitude = 0;
        this.longitude = 0;
      }
    },
    openImageGallery() {
      this.$refs.imageGalleryRef.toggleDialog();
    },
    galleryImageSelectedForContent(image) {
      console.log('Image', image);
      this.selectedFromGalleryForContent = image ? true : false;
      this.image.thumbnail = image.thumbnail;
      this.image.url = image.url;
    },
    galleryImageSelectedForNextStep(image) {
      this.selectedFromGalleryForNextStep = image ? true : false;
      this.subCollections.image.url = image.url ? image.url : '';
      this.subCollections.image.thumbnail = image.thumbnail;
      this.subCollections.image.url = image.url;
    },
    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    toggleDialog(details, action) {
      this.dialog = !this.dialog;
      if (this.dialog) {
        console.log('Edit Details: ', details);
        this.dialogAction = action;
        this.id = details.id;
        if (action != 'copy') {
          this.scheduledAtDateField = details.scheduledAt
            ? details.scheduledAt.seconds * 1000
            : '';
          this.expireAtDateField = details.data.expiresAt
            ? details.data.expiresAt.seconds * 1000
            : '';
          this.scheduledAt = this.iMoment(details.scheduledAt.seconds * 1000);
          this.expiresAt = this.iMoment(details.data.expiresAt.seconds * 1000);
        }
        this.state = details.state;
        this.region = details.region;
        this.entity = details.entity;
        this.placement = details.data.placement;
        this.createdBy = details.createdBy;
        this.content = details.data.content;
        this.subCollections.toInsert.message =
          details.data.subCollections.toInsert.message;
        this.subCollections.image.url = details.data.subCollections.image.url
          ? details.data.subCollections.image.url
          : '';
        this.subCollections.image.thumbnail =
          details.data.subCollections.image.thumbnail;
        this.image.thumbnail = details.data.image
          ? details.data.image.thumbnail
          : '';
        this.image.url = details.data.image ? details.data.image.url : '';
      }
    },
    openExpiryDateDialog() {
      this.$refs.ExpiryTimeAndDateDialogRef.toggleDialog(
        this.expiresAtDateField,
      );
    },
    onExpiryDateSelected(dateTime) {
      // console.log("Expiry Selected Date and Time: ", dateTime);
      this.expiresAtDateField = dateTime;
    },
    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(
        this.scheduledAtDateField,
      );
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
    },
    cancel() {
      this.scheduledAtDateField = '';
      this.expiresAtDateField = '';
      this.scheduledAt = '';
      this.region = '';
      this.entity = '';
      this.state = '';

      this.content = '';
      this.cost = 0;
      this.image = {};
      this.location = {};
      this.placement = '';

      this.expiresAt = '';
      this.subCollections = {
        image: {
          url: '',
          thumbnail: '',
        },
        collectionName: 'nextstep',
        toInsert: {
          attachment: '',
          for: 'user',
          message: '',
          state: '',
        },
      };
      if (this.selectedFromGalleryForContent == true) {
        this.$refs.galleryImageSelectSectionContentRef.galleryImageDeselect();
      }

      if (this.selectedFromGalleryForNextStep == true) {
        this.$refs.galleryImageSelectSectionRef.galleryImageDeselect();
      }
      this.selectedFromGalleryForContent = false;
      this.selectedFromGalleryForNextStep = false;

      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);
      if (!this.scheduledAtDateString) {
        alert('Yo yo, Slow down dude, add a Scheduled At time');
        return;
      }

      if (this.dialogAction === 'copy') {
        console.log('COPY: ', this.changeFieldsCopy);
        this.createNewPerk({
          details: this.changeFieldsCopy,
          collection: this.collection,
          type: 'Perk',
        }).then(() => {
          this.dialog = false;
          this.getPerksByRegion({
            type: 'perk',
            collection: this.collection,
            mutation: 'updatePerks',
            region: this.selectedRegion,
          });
        });
      } else {
        console.log('UPDATE', this.changeFields);
        this.updatePerk({
          details: this.changeFields,
          collection: this.collection,
          type: 'Perk',
        }).then(() => {
          this.cancel();
          this.getPerksByRegion({
            type: 'perk',
            collection: this.collection,
            mutation: 'updatePerks',
            region: this.selectedRegion,
          });
        });
      }
    },
  },
};
</script>

<style>
.cropper {
  height: 600px;
  background: #ddd;
}
</style>
